import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Folder, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeFolder(request: Boundaries["removeFolder"]["request"]): void;
}

function useRemoveFolder(folder: Identifiable<Folder>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveFolderRequestPending(folder),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveFolderRequestSuccess(folder),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveFolderRequestFailure(folder),
    ),
    removeFolder: core.removeFolder,
  };
}

export { useRemoveFolder };
